import { useState, useEffect } from "react";
import { Activity } from "lucide-react";
import { EndpointList } from "./components/EndpointList";
import { UserInfo } from "./components/UserInfo";
import { pingEndpoint, getUserInfo } from "./utils/ping";
import type { Endpoint, UserInfo as UserInfoType } from "./types";

const defaultEndpoints: Omit<Endpoint, "id">[] = [
  {
    name: "Server xomdua",
    url: "https://sg1b.langdua.net/ping",
    sni: "sg1b.langdua.net",
    status: "pending",
    latency: null,
    lastChecked: null,
  },
];

function App() {
  const [endpoints, setEndpoints] = useState<Endpoint[]>(() =>
    defaultEndpoints.map((endpoint) => ({
      ...endpoint,
      id: crypto.randomUUID(),
    }))
  );
  const [userInfo, setUserInfo] = useState<UserInfoType | null>(null);

  useEffect(() => {
    getUserInfo().then(setUserInfo);
  }, []);

  const checkEndpoint = async (id: string) => {
    setEndpoints((prev) =>
      prev.map((endpoint) =>
        endpoint.id === id ? { ...endpoint, status: "pending" } : endpoint
      )
    );

    const endpoint = endpoints.find((e) => e.id === id);
    if (!endpoint) return;

    const result = await pingEndpoint(endpoint.url);

    setEndpoints((prev) =>
      prev.map((endpoint) =>
        endpoint.id === id
          ? {
              ...endpoint,
              status: result.success ? "online" : "offline",
              latency: result.latency,
              lastChecked: new Date(),
              statusCode: result.statusCode,
              error: result.error,
            }
          : endpoint
      )
    );
  };

  // Initial check of all endpoints
  useEffect(() => {
    endpoints.forEach((endpoint) => checkEndpoint(endpoint.id));
  }, []); // Run once on mount

  // Check all endpoints every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      endpoints.forEach((endpoint) => checkEndpoint(endpoint.id));
    }, 30000);

    return () => clearInterval(interval);
  }, [endpoints]);

  return (
    <div className="min-h-screen bg-gray-100 [&_*]:font-sans">
      <div className="max-w-4xl mx-auto p-6">
        <div className="flex items-center space-x-3 mb-8">
          <Activity className="w-8 h-8 text-blue-500" />
          <h1 className="text-3xl font-bold text-gray-900">
            Kiểm tra kết nối cơ bản
          </h1>
        </div>

        <div className="space-y-6">
          <UserInfo userInfo={userInfo} />

          <EndpointList endpoints={endpoints} />

          <div className="w-full text-center">
            <span className="text-xs opacity-15">Gladly check your router</span>
            {/* <span className="select-all text-xs text-center opacity-15">
              {[
                userInfo?.ip?.replace(/\s/g, ""),
                endpoints
                  .map(
                    (endpoint) =>
                      `${endpoint.url}:${endpoint.statusCode || -1}+${
                        endpoint.latency
                      }${endpoint.error ? `(${endpoint.error})` : ""}`
                  )
                  .join(";"),
              ].join("|")}
            </span> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
